import TextField, { TextFieldProps } from '@mui/material/TextField';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { inputEventHandler } from '../utils/inputEventHandler';

type PhoneNumberDisabledInputProps = {
  inputLabelKey: string;
  slotProps?: TextFieldProps['slotProps'];
  value: string;
};

/**
 * PhoneNumberDisabledInput
 *
 * A disabled version of the PhoneNumberInput component. Used to display a phone number that cannot be edited.
 */
export const PhoneNumberDisabledInput = ({
  inputLabelKey,
  slotProps,
  value,
}: PhoneNumberDisabledInputProps): ReactNode => {
  const { t } = useTranslation();

  const defaultValue = inputEventHandler.phoneNumber.formatter(value);

  return (
    <TextField
      defaultValue={defaultValue}
      label={t(inputLabelKey)}
      slotProps={slotProps}
      style={{ pointerEvents: 'none' }}
      variant="outlined"
      disabled
      fullWidth
    />
  );
};
